import { createRouter, createWebHistory } from 'vue-router'
import { useAuthenticator } from '@aws-amplify/ui-vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/muestra',
    name: 'Muestra',
    component: () => import('../pages/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../pages/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/'), 
  routes
})

// Add navigation guard
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      const { authStatus, user } = useAuthenticator()
      
      // If we're already authenticated, proceed immediately
      if (authStatus === 'authenticated') {
        next()
        return
      }
      
      // If we're on the initial load, wait a brief moment for auth to initialize
      if (authStatus === 'configuring') {
        // Wait for a short time to let authentication initialize
        await new Promise(resolve => setTimeout(resolve, 100))
        
        // Check auth status again
        const { authStatus: currentStatus } = useAuthenticator()
        if (currentStatus === 'authenticated') {
          next()
          return
        }
      }
      
      // If still not authenticated, redirect to login
      next('/login')
    } catch (error) {
      console.error('Auth error:', error)
      next('/login')
    }
  } else {
    next()
  }
})

export default router 